import { Checkout } from '../components';

const CheckoutPage = () => (
  <main className="main">
    <Checkout />
  </main>
);

export default CheckoutPage;
